import {connect} from 'react-redux';
import CaptainPaymentListItem from './CaptainPaymentListItem.jsx';
import {
  handleViewEntriesClick,
  handlePrintConfirmationClick
} from './actions';

const mapStateToProps = (state, props) => props;

const mapDispatchToProps = dispatch => ({
  onViewEntriesClick: paymentId => dispatch(handleViewEntriesClick(paymentId)),
  onPrintConfirmationClick: paymentId => dispatch(handlePrintConfirmationClick(paymentId))
});

export default connect(mapStateToProps, mapDispatchToProps)(CaptainPaymentListItem);



// WEBPACK FOOTER //
// ./src/features/admin/captainDetail/CaptainPaymentListItemContainer.jsx